import React from "react";
import styles from "./sobre_mim_suellendiastattoo.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const Sobre_mim_suellendiastattoo: React.FC = () => {

    return (
        <div className={styles.sobre_mim_suellendiastattoo}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/suellendiastattoo" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <img src={require("./src/img_sobremim.png")} alt="Suellen Dias Tattoo" />
                </div>
                <h2>Suellen Dias</h2>
                <p>Sou tatuadora e body piercer. Meu trabalho vai além da estética: busco oferecer uma experiência única, onde cada traço carrega identidade e significado.</p>
                <p>Atuo com diversos estilos de tatuagem, desde traços finos e delicados até composições mais marcantes e complexas. Essa versatilidade me permite criar projetos personalizados que se encaixam em diferentes gostos e propostas. No body piercing, mantenho sempre o foco em técnica, segurança e cuidado, valorizando a individualidade de cada cliente.</p>
                <p>Fui premiada mais de 10 vezes em eventos de tatuagem, conquistas que refletem minha evolução constante e amor pela arte.</p>
                <p>Acredito que a pele é uma tela viva, e cada trabalho é uma forma de expressão, liberdade e conexão. Meu compromisso é transformar cada ideia em arte com profissionalismo, sensibilidade e criatividade.</p>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>


                    <a href="https://wa.me/5518996372323?text=Olá, vim pelo link na bio e gostaria de mais informações..." target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/LQDpfj9V1v2gGUM8A" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href="https://www.instagram.com/suellendias.tattoo?igsh=MWx0bGJsOGIwNnE1ag==" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobre_mim_suellendiastattoo;
